import type { ILearningObjectNoteResponse } from '@/services';
import type { INoteData } from '@/entities';

export const mapPrimeLearningObjectNote = (data: ILearningObjectNoteResponse): INoteData => {
  return {
    id: data.id,
    text: data.attributes.text,
    marker: data.attributes?.marker || '1'
  };
};
